// extracted by mini-css-extract-plugin
module.exports = {"base":"TrialChart_base__3r_wW","spinner":"TrialChart_spinner__3x_JY"};